import { WishlistsBackInStockItemSchema } from "@apps/wishlist/schemas/WishlistsBackInStockItemSchema";
import { array, object } from "superstruct";

export const GetBackInStockItemsResponseSchema = object({
    results: array(WishlistsBackInStockItemSchema),
});
